<template>
    <div id="Rules">
        <div class="container">
            <div class="description">
                <div class="row margin-left-right">
                    <div class="col min">
                        <div class="title">
                        Rules
                        </div>
                        <br/>
                        <ul type="square">
                        <li>You can buy tickets with SHUF, ETH or any ERC20.</li>
                        <li>The more tickets you have, the bigger is your chance to win.</li>
                        <li>Every <b>5 days + 12 hour</b> someone has to close the raffle. Right after that someone has to pick the winner.</li>
                        <li>Whoever closes the raffle and whoever picks the winner get rewarded <b>{{pickerreward}} SHUF each!</b></li>
                        <li>Sorry, only two people will be able to get rewarded each week! (rest of the txs will fail)</li>
                        <li>After each raffle <b>{{preserve}} %</b> of the prize is held in the dapp to kickstart the next raffle!</li>
                        <li>If there are less than {{mintickets}} tickets purchased the raffle will get <b>extended</b> for another week.</li>
                        <li>The raffle runs on a smart contract and its trustless</li>
                        <li><b>DON'T</b> send SHUF or anything else directly to the contract... If you do, it will be lost and cannot be recovered.</li>
                        <li>Special thanks to <b>THE GHOST</b> for helping me out and advising me on my code.</li>
                        <li>The Shuffle Raffle <b>HAS NOT BEEN AUDITED</b> and if it gets compromised <b>I will not be held liable</b> for any losses you might suffer.</li>
                        <li>You can find the smart contract code <a href="https://etherscan.io/address/0x1235f3f2bB5f69BcEB5425CDc83cB1163190D9bB#code" target="_blank">here</a></li>
                        <li>If you win BIG, go on and press the big red <b>donate button</b>.</li>
                        <li><b>GOOD LUCK!</b></li>
                        </ul>
                    </div>
                    <div class="col min mobile-top-margin">
                        <div class="title">
                            About me
                        </div>              
                        <img alt="Expect nothing less." class="hanzo" src="../assets/hanzo.png"/>
                        <ul type="square">
                            <li>My name is George.</li>
                            <li>I am an early member of the SHUF community.</li>
                            <li>I like computers, blockchains and shuffled monsters.</li>
                            <li>I learned solidity and js just for this project.</li>
                            <li>I had fun making this.</li>
                        </ul>
                        <!-- button 1 -->
                        <div class="button-box-container" v-if="!donate_active">
                        <br/>
                        <div class="title">
                            Donate Button:
                        </div><br/><br/>
                        <div v-on:click="donate_active = true"  class="button-box">
                            <div class="select-button"></div>                   
                        </div>
                        </div>
                        <transition name="bounce"> 
                            <div v-if="donate_active" class="auto QRtxt">
                                <b style="font-size:20px;">Thanks for your Support!</b><br/>
                                ETH & SHUF
                                <img alt="Thanks" class="QR auto" src="../assets/qr.png"/>                
                                <span class="addy">0x8fDd2E75daaFe18b315d89971158D7EE211EE111</span>                   
                            </div>
                        </transition>
                    </div>
                </div>      
            </div>    
        </div>
    </div>
</template>

<script>
export default {
  name: 'Rules',
  data:function(){
      return {
        donate_active:false,
        mintickets: this.mintickets,
        pickerreward: this.pickerreward,
        preserve:this.preserve
      } 
  },
  mounted() {

    this.$root.$on('mintickets', data => {
        this.mintickets=data;
    }),

    this.$root.$on('pickerreward', data => {
        this.pickerreward=data;
    });

     this.$root.$on('preserve', data => {
        this.preserve=data;
    });
},
  
}
</script>

<style scoped>
@import '../assets/css/button1.css';

.button-box-container{
    display: block;
    text-align: center;
    margin: 40px auto;
}
.QR{
    display: block;
    text-align: center;
    padding:10px;
    width: 190px;
}
.QRtxt{
    margin-top:50px !important;
    text-align: center;
}
li:not(:last-child) { 
    padding-bottom: 0px;
}
li{
    margin: 8px 0;
}
ul{
    padding-left: 20px;
}
.margin-left-right{
    margin-left: 50px;
    margin-right: 50px;
}
.min {
    padding: 0 50px;
    min-width: 300px; 
    line-height: 1.6em;
}
.hanzo{
    width:100px;
    display: block;
    margin: 30px auto;
}
.container{
    width: auto;
    margin-top: 66px;
    margin-bottom: 66px;
}
.auto{
    margin: auto;
}
.title, .description{
    position: static;
    color: #000000;
    align-items: center;
}
.title{
    max-width: 731px;
    font-weight: 600;
    font-size: 35px; 
    line-height: 93.19%;
    text-align: center;
    display: block;
    letter-spacing: -0.02em;   
}
.description{
    font-weight: 400;
    font-size: 15px;
    text-align: left;
}

@media screen and (max-width: 767px) {
    .margin-left-right {
        margin-left: 16px !important;
        margin-right: 16px !important;
    }
    .min{padding: 0px;    }
    .mobile-top-margin {margin-top:35px;}
    .addy{margin-left: -15px !important;}
}

/* transition */
.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}
</style>
